"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportFundCheckUniqueApi = reportFundCheckUniqueApi;
exports.reportFundCreateApi = reportFundCreateApi;
exports.reportFundDeleteAllApi = reportFundDeleteAllApi;
exports.reportFundDeleteApi = reportFundDeleteApi;
exports.reportFundFindApi = reportFundFindApi;
exports.reportFundFindCurrentFiscalApi = reportFundFindCurrentFiscalApi;
exports.reportFundFindDetailsApi = reportFundFindDetailsApi;
exports.reportFundListApi = reportFundListApi;
exports.reportFundListRestoreSoftApi = reportFundListRestoreSoftApi;
exports.reportFundRestoreSoftDeleteApi = reportFundRestoreSoftDeleteApi;
exports.reportFundSoftDeleteApi = reportFundSoftDeleteApi;
exports.reportFundUpdateApi = reportFundUpdateApi;
exports.reportFundtDataYearListApi = reportFundtDataYearListApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * search report fund with params
 * @param payload
 * @returns api response
 * @description this function used to search report fund with params.
 */
function reportFundFindApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.fund), params);
}

/**
 * find report fund details with params
 * @param payload
 * @returns api response
 * @description this function used to find report fund details with params.
 */
function reportFundFindDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.details), params);
}

/**
 * report fund list with params
 * @param payload
 * @returns api response
 * @description this function used to report fund list with params.
 */
function reportFundListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.list), params);
}

/**
 * report find fund current fiscal
 * @param payload
 * @returns api response
 * @description this function used to report find fund current fiscal.
 */
function reportFundFindCurrentFiscalApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.fiscalYear));
}

/**
 * Check report fund is unique or not
 * @param payload
 * @returns api response
 * @description this function used to check report fund is unique.
 */
function reportFundCheckUniqueApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.uniqueReferenceNo), params);
}

/**
 * report fund create
 * @param payload
 * @returns api response
 * @description this function used to report fund create given inputs.
 */
function reportFundCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.fund), params);
}

/**
 * report fund update
 * @param payload
 * @returns api response
 * @description this function used to update report fund given inputs.
 */
function reportFundUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.fund), params);
}

/**
 * report fund delete
 * @param payload
 * @returns api response
 * @description this function used to delete report fund of given params.
 */
function reportFundDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.fund), params);
}

/**
 * report fund report data
 * @param payload
 * @returns api response
 * @description this function used to get report fund report data.
 */
function reportFundtDataYearListApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.year.list));
}

/**
 * report fund delete
 * @param payload
 * @returns api response
 * @description this function used to delete report fund of given params.
 */
function reportFundDeleteAllApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.deleteAll), params);
}
function reportFundSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.softDelete), params);
}
function reportFundRestoreSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.softDeleteRestore), params);
}
function reportFundListRestoreSoftApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.fund.softDeleteList), params);
}